import * as s from "./website-black-flow-grid.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackGridWhiteComponent} from "../../grid/white/WebsiteBlackGridWhiteComponent";
import {IWebsiteBlackFlowGrid} from "./types/IWebsiteBlackFlowGrid";

export class WebsiteBlackFlowGridComponent extends Component {

    constructor(flow: IWebsiteBlackFlowGrid) {
        super();

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackFlowGrid}">
                <h2 class="${s.bigTitle}" ${flow.titleMaxWidth ? `style="max-width: ${flow.titleMaxWidth}px;"` : ``}>
                    ${flow.title}
                </h2>
                ${flow.description ? `<p class="${s.description}">${flow.description}</p>` : ``}
                ${this.draw(new WebsiteBlackGridWhiteComponent(flow.lines))}
            </div>
        `;
    }
}